import { triggerBackofficeAutosave } from "packs/init-backoffice-autosave"

const BACKOFFICE_SWAL = {
  customClass: {
    popup: "backoffice-swal",
    title: "backoffice-swal__title",
    htmlContainer: "backoffice-swal__body",
    icon: "backoffice-swal__icon",
    actions: "backoffice-swal__actions",
    confirmButton: "backoffice-swal__confirm",
    cancelButton: "backoffice-swal__cancel",
  },
  buttonsStyling: false,
  reverseButtons: true,
  width: "400px",
  padding: "1.25rem 1.25rem 1rem",
}

const initHallChangeConfirmation = () => {
  const form = document.querySelector("[data-hall-confirmation-form]")
  if (!form) return

  const hallSelect = form.querySelector("[data-hall-select]")
  if (!hallSelect) return

  if (hallSelect.dataset.hallBound === "true") return
  hallSelect.dataset.hallBound = "true"

  hallSelect.addEventListener("change", () => {
    const originalHall = hallSelect.dataset.originalHall

    if (hallSelect.value === originalHall) {
      triggerBackofficeAutosave(form)
      return
    }

    Swal.fire({
      ...BACKOFFICE_SWAL,
      title: "Changer de hall ?",
      html:
        `Passage du hall <strong>${originalHall}</strong> au hall <strong>${hallSelect.value}</strong>.` +
        `<br><br>Cela impacte le plan des stands (et éventuellement le catalogue premium).` +
        `<br>Les stands déjà générés <strong>ne sont pas régénérés</strong>.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Changer le hall",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (!result.isConfirmed) {
        hallSelect.value = originalHall
        return
      }

      hallSelect.dataset.originalHall = hallSelect.value
      triggerBackofficeAutosave(form)
    })
  })
}

export { initHallChangeConfirmation }
